import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Spinner } from 'react-bootstrap';

const EstadoCuentaHeader = ({ rfcSeleccionado, cargando, handleSeleccionarArchivo, cuentaSeleccionada, movimientosSeleccionados = [], setShowModalEliminar, handleGenerarReportePDF }) => {
    return (
        <Row className="align-items-center">
            <Col>
                <h5 className="mb-0 text-dark fw-bold">
                    <i className="fas fa-file-invoice-dollar me-2 text-primary"></i>
                    Estado de Cuenta Bancario
                </h5>
            </Col>
            <Col xs="auto" className="d-flex gap-2">
                <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={handleGenerarReportePDF}
                    disabled={!rfcSeleccionado || !cuentaSeleccionada || cargando}
                    title="Generar Reporte PDF de Conciliación"
                >
                    <i className="fas fa-file-pdf me-1"></i>
                    Reporte
                </Button>
                {movimientosSeleccionados.length > 0 && (
                    <Button
                        variant="danger"
                        size="sm"
                        onClick={() => setShowModalEliminar(true)}
                        disabled={cargando}
                    >
                        <i className="fas fa-trash-alt me-1"></i>
                        Eliminar ({movimientosSeleccionados.length})
                    </Button>
                )}
                <Button
                    variant="primary"
                    size="sm"
                    onClick={() => document.getElementById('fileInput').click()}
                    disabled={!rfcSeleccionado || !cuentaSeleccionada || cargando}
                >
                    {cargando ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-1" />
                            Importando...
                        </>
                    ) : (
                        <>
                            <i className="fas fa-upload me-1"></i>
                            Importar
                        </>
                    )}
                </Button>
                <input
                    id="fileInput"
                    type="file"
                    accept=".csv"
                    style={{ display: 'none' }}
                    onChange={handleSeleccionarArchivo}
                />
            </Col>
        </Row>
    );
};



EstadoCuentaHeader.propTypes = {
    rfcSeleccionado: PropTypes.string,
    cargando: PropTypes.bool,
    handleSeleccionarArchivo: PropTypes.func,
    cuentaSeleccionada: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    handleGenerarReportePDF: PropTypes.func
};

export default EstadoCuentaHeader;
